import type { AdminPayment, AdminPaymentHistory } from "@/types/admin-payments";
import type { MockUserId } from "@/lib/api/mock-data/users.mock";

/**
 * Mock payment histories — mirror the gateway `AdminPaymentHistory` returned by
 * `GET /admin/users/{user_id}/payments` (W65-3): captured Stripe charges only,
 * newest first, with refunds and Stripe's hosted receipt. A trial member who was
 * never charged has none (the $1 card check is not a payment). Charge ids and
 * receipt links are made up, shaped like Stripe's.
 */
function paid(
  id: string,
  paidAt: string,
  amountCents: number,
  kind: AdminPayment["kind"],
  refundedCents = 0,
): AdminPayment {
  return {
    id,
    paidAt,
    amountCents,
    currency: "usd",
    refundedCents,
    kind,
    receiptUrl: `https://pay.stripe.com/receipts/payment/mock_${id}`,
  };
}

function history(...payments: AdminPayment[]): AdminPaymentHistory {
  return { available: true, payments, reason: null };
}

export const MOCK_PAYMENTS: Record<MockUserId, AdminPaymentHistory> = {
  // Year two: the renewal, then the first year.
  u_001_alice_active: history(
    paid("ch_mock_alice_2", "2026-05-01T09:00:00Z", 34800, "membership"),
    paid("ch_mock_alice_1", "2025-05-01T09:00:00Z", 34800, "membership"),
  ),
  u_002_bob_trial_pending: history(),
  u_003_cara_trial_ending: history(),
  // The day-31 charge failed, so nothing was taken (see Membership → Billing retry).
  u_004_dave_card_failed: history(),
  u_005_erin_charged_off: history(),
  u_006_finn_past_due: history(paid("ch_mock_finn_1", "2025-06-10T10:00:00Z", 34800, "membership")),
  // A prepaid year, then an at-cost replacement pair.
  u_007_gina_suspended: history(
    paid("ch_mock_gina_2", "2026-04-02T14:20:00Z", 19900, "replacement"),
    paid("ch_mock_gina_1", "2025-08-15T08:30:00Z", 34800, "prepaid_membership"),
  ),
  // Cancelled inside the trial window and refunded in full.
  u_008_hugo_cancelled: history(
    paid("ch_mock_hugo_1", "2025-11-03T12:00:00Z", 34800, "membership", 34800),
  ),
};
